// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout_container__Ahs6S","container_main":"MainLayout_container_main__35GVM"};